import React, { useCallback } from 'react';
import { CustomSelect } from 'apps/sigma2-ui/src/components/ui/CustomSelect';
import { ViewMode } from 'libs/end-to-end/src/view-configurations';
import { DEFAULT_VIEW_MODE } from 'apps/sigma2-ui/src/explore-section/components/TableViewConfig';
import { TableViewModelOption } from 'apps/sigma2-ui/src/explore-section/components/TableViewConfig';
import { ViewConfigurationSchema } from 'libs/end-to-end/src/view-configurations';
import { viewModeOptions } from 'apps/sigma2-ui/src/explore-section/components/TableViewConfig';

interface ViewModeSelectorProps {
  viewConfiguration: ViewConfigurationSchema;
  defaultViewMode?: ViewMode;
  setViewConfiguration?: (viewConfiguration: ViewConfigurationSchema) => void;
  options?: TableViewModelOption[];
}

export const ViewModeSelector = (props: ViewModeSelectorProps) => {
  const {
    setViewConfiguration,
    viewConfiguration,
    options,
    defaultViewMode = DEFAULT_VIEW_MODE,
  } = props;

  const viewModeChangeCb = useCallback(
    (viewMode: ViewMode) => {
      if (setViewConfiguration && viewConfiguration) {
        const selectedOption = viewModeOptions?.find(
          (option) => option.value === viewMode,
        );
        const updatedViewConfiguration = selectedOption?.updateViewConfiguration
          ? selectedOption.updateViewConfiguration(viewConfiguration)
          : viewConfiguration;

        setViewConfiguration({
          ...updatedViewConfiguration,
          defaultViewMode: viewMode,
        });
      }
    },
    [setViewConfiguration, viewConfiguration],
  );

  return (
    <div className="flex items-center gap-2 group-[]/dashboard:ml-4">
      <CustomSelect
        selectedValue={viewConfiguration?.defaultViewMode ?? defaultViewMode}
        options={options ?? viewModeOptions}
        onChange={viewModeChangeCb}
      />
    </div>
  );
};
